import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-no-result',
    templateUrl: './no-result.component.html',
    styleUrls: ['./no-result.component.scss'],
})
export class NoResultComponent {
    constructor(private translate: TranslateService) {}

    @Input() reduced: boolean;
}
